import { useRef, useEffect } from "react";

const FocusOutside = ({ clickedOutside, children }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Dropdown-Selects ignorieren
      const selectDropdowns = document.querySelectorAll(".ant-select-dropdown");
      const clickedInsideDropdown = Array.from(selectDropdowns).some((dropdown) =>
        dropdown.contains(event.target)
      );
      if (clickedInsideDropdown) return;

      // Prüfen ob der Klick **nicht innerhalb des aktuellen Containers** war
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        // Ganz leicht verzögern, damit setEditing(true) von z. B. Inputs vorher feuert
        setTimeout(() => {
          clickedOutside();
        }, 0);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, [clickedOutside]);

  return (
    <div ref={containerRef} style={{ position: "relative", zIndex: 1 }}>
      {children}
    </div>
  );
};

export default FocusOutside;
